"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _link = _interopRequireDefault(require("../../../core/link"));
var _deleteButton = _interopRequireDefault(require("../../../core/delete-button"));
var _constants = require("../../../../stripe/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // ************************************************************************
// ******************** DEVELOPER WARNING *********************************
// ******* This component is also used by the checkout/success ************
// ************************************************************************
var _ref = /*#__PURE__*/_react.default.createElement("td", null);
var _ref2 = /*#__PURE__*/_react.default.createElement("td", {
  className: "text-muted"
}, "Race in past");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "You have no entries for this year yet");
var _ref4 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Please Note: \"Draft\" are those entries in your shopping basket that you have started but for which you have not supplied payment details. If you have not supplied payment details you do not have an entry!");
var _ref5 = /*#__PURE__*/_react.default.createElement("p", null, "Your card will normally be charged about ", _constants.chargeLeadTime, " days before the competition");
class MyEntries extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_paymentStatus", entry => {
      if (!entry.payment || !entry.payment.paymentStatusDescription) return _ref;
      const textColor = entry.payment.paymentStatusRef === 'PAID' ? 'text-success' : entry.payment.paymentStatusRef === 'ERR' ? 'text-danger' : undefined;
      return /*#__PURE__*/_react.default.createElement("td", {
        className: textColor
      }, entry.payment.paymentStatusDescription);
    });
    _defineProperty(this, "_entryStatus", entry => {
      if (this._isInPast(entry)) {
        return _ref2;
      }
      return /*#__PURE__*/_react.default.createElement("td", {
        className: entry.eligibilityStatus.textClass
      }, entry.eligibilityStatus.text);
    });
    _defineProperty(this, "_isInPast", entry => {
      const today = new Date().toISOString().split('T')[0];
      return entry.race.competitionDay.dayDate <= today;
    });
    _defineProperty(this, "_muteIfInPast", entry => {
      if (this._isInPast(entry)) return 'text-muted';
    });
    _defineProperty(this, "_competitionURL", entry => {
      return `/year/${this.props.yearID}/competition/` + entry.competition.competitionSlug;
    });
  }
  render() {
    const entryStatusDescriptions = [];
    const entriesByStatus = {};
    for (const entry of this.props.userEntriesByYear) {
      if (!entriesByStatus[entry.entryStatusDescription]) {
        entryStatusDescriptions.push(entry.entryStatusDescription);
        entriesByStatus[entry.entryStatusDescription] = {
          entries: []
        };
      }
      entriesByStatus[entry.entryStatusDescription].entries.push(entry);
    }
    if (!this.props.userEntriesByYear.length) {
      return _ref3;
    }
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "The following is a summary of your future races in ", this.props.yearID, ". It will only include entries that have been placed online whilst logged in using your current email."), _ref4, _ref5, entryStatusDescriptions.map(entryStatus => /*#__PURE__*/_react.default.createElement("div", {
      key: entryStatus
    }, /*#__PURE__*/_react.default.createElement("h3", null, entryStatus), /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("tbody", null, entriesByStatus[entryStatus].entries.map(entry => /*#__PURE__*/_react.default.createElement("tr", {
      key: entry.id
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_link.default, {
      "data-test-id": 'competition-link-' + entry.competitionID,
      to: this._competitionURL(entry),
      className: this._muteIfInPast(entry)
    }, entry.competition.competitionName)), /*#__PURE__*/_react.default.createElement("td", {
      className: this._muteIfInPast(entry)
    }, (0, _occasion.default)(entry.race.competitionDay.dayDate, 'ddd DD MMM')), /*#__PURE__*/_react.default.createElement("td", {
      className: this._muteIfInPast(entry)
    }, entry.race.raceName), /*#__PURE__*/_react.default.createElement("td", {
      className: this._muteIfInPast(entry)
    }, "Bib ", entry.startListBib, " - ", entry.bibName), this._entryStatus(entry), this._paymentStatus(entry), /*#__PURE__*/_react.default.createElement("td", null, this._isInPast(entry) || !entry.eligibilityStatus.canRemoveEntry ? null : /*#__PURE__*/_react.default.createElement(_deleteButton.default, {
      onClick: this.props.onRemove.bind(this, entry.id),
      size: "sm"
    })))))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref6 = {
  id: true,
  startListBib: true,
  bibName: true,
  entryStatusDescription: true,
  competition: {
    competitionName: true,
    competitionSlug: true
  },
  rtcRefs: true,
  race: {
    raceName: true,
    competitionDay: {
      dayDate: true
    }
  },
  eligibilityStatus: {
    canRemoveEntry: true,
    text: true,
    textClass: true
  },
  payment: {
    paymentStatusRef: true,
    paymentStatusDescription: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(MyEntries, props => ({
  ["userEntriesByYear(yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref6
}), (client, props) => ({
  onRemove(entryID) {
    return client.update('Entry.remove', {
      entryID
    });
  }
}));